module.exports = __webpack_public_path__ + "static/img/16.4998324.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/16.png
// module id = r3CP
// module chunks = 0